import { useShowContext } from 'framework/show';
import { Box, Typography } from '@mui/material';
import { HtmlField } from 'framework/ui/field';
import { VacancyProject } from 'domain/shared/newVacancy';
import { SwiperContainer } from 'framework/ui/ui-builder';

const VacancyProjectsSwiper = () => {
  const { data } = useShowContext();
  const { projects } = data.getData();

  return (
    <SwiperContainer>
      {projects.map((project: VacancyProject & { id: string }) => {
        return (
          <Box sx={{ height: '340px' }}>
            <Typography variant="h4" color="primary" mb={{ xs: 3.5, sm: 3.75 }}>
              {project.name}
            </Typography>
            <Box sx={{ maxHeight: '255px', overflow: 'auto' }}>
              <HtmlField value={project.description} label="" />
            </Box>
          </Box>
        );
      })}
    </SwiperContainer>
  );
};

export default VacancyProjectsSwiper;
